import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaSave, FaArrowLeft } from "react-icons/fa";
import { TbCategory2 } from "react-icons/tb";
import { toast } from "react-toastify";
import { addFeatures, clearState } from "../../redux/Slices/FeaturesSlice";
import { validateFieldLanguage } from "../../Utils/languageValidation";

const AddFeature = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title_ar: "",
    title_en: "",
    status: "",
    logo: "",
  });

  const { isLoading: loading, error, success } = useSelector((state) => state.features);

  useEffect(() => {
    dispatch(clearState());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      toast.success("تمت الإضافة بنجاح");
      dispatch(clearState());
      navigate("/features");
    }
    if (error) {
      toast.error("لم تتم الإضافة");
      dispatch(clearState());
    }
  }, [success, error, dispatch, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!validTypes.includes(file.type)) {
      toast.error("الملف يجب أن يكون صورة (jpg, jpeg, png)");
      e.target.value = "";
      return;
    }

    setFormData((prev) => ({ ...prev, [e.target.name]: file }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // BUG-11 fix: التحقق من لغة الحقول قبل الإرسال
    const arError = validateFieldLanguage(formData.title_ar, "ar");
    if (arError) return toast.error(arError);
    const enError = validateFieldLanguage(formData.title_en, "en");
    if (enError) return toast.error(enError);

    dispatch(clearState());

    const data = new FormData();
    data.append("title_ar", formData.title_ar);
    data.append("title_en", formData.title_en);
    data.append("status", formData.status);

    if (formData.logo) {
      data.append("logo", formData.logo);
    }

    dispatch(addFeatures(data));
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div className="container-fluid" style={{ direction: "rtl", padding: "4px 0" }}>
      <style>{`
        .feat-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .feat-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
        .file-input-wrapper {
          position: relative;
          width: 100%;
        }
      `}</style>

      {/* ── Header ─────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800, color: "#0f172a", fontSize: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <TbCategory2 style={{ color: "var(--gray-color)" }} /> إضافة ميزة جديدة
          </h4>
          <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: 13 }}>إدخال بيانات الميزة واللوجو الخاص بها للعملاء</p>
        </div>
        <Link to="/features" style={{ textDecoration: "none" }}>
          <button style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 18px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer", fontSize: 13 }}>
            <FaArrowLeft size={11} /> العودة
          </button>
        </Link>
      </div>

      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>العنوان (عربي) *</label>
              <input
                type="text"
                name="title_ar"
                value={formData.title_ar}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="أدخل العنوان بالعربية..."
                required
              />
            </div>

            <div>
              <label style={labelStyle}>العنوان (إنجليزي) *</label>
              <input
                type="text"
                name="title_en"
                value={formData.title_en}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="Enter title in English..."
                required
                dir="ltr"
              />
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>لوجو الميزة (صورة) *</label>
              <input
                type="file"
                name="logo"
                required
                onChange={handleFileChange}
                style={{ ...inputStyle, padding: "8px 12px" }}
              />
            </div>

            <div>
              <label style={labelStyle}>الحالة *</label>
              <select
                className="feat-custom-select"
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>اختر الحالة...</option>
                <option value="1">🟢 مفعل</option>
                <option value="0">🔴 غير مفعل</option>
              </select>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 10 }}>
            <button
              type="button"
              onClick={() => navigate("/features")}
              style={{ padding: "10px 20px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer", fontSize: 14 }}
            >
              إلغاء
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: "10px 28px",
                borderRadius: 10,
                border: "none",
                background: loading ? "#c7d2fe" : "linear-gradient(135deg,var(--main-color),var(--main-light))",
                color: "#fff",
                fontWeight: 700,
                cursor: loading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 14
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" />
                  جاري الحفظ...
                </>
              ) : (
                <>
                  <FaSave size={12} />
                  حفظ الميزة
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFeature;
